// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Xzd6","inputWrap":"CustomTip_inputWrap__1V96B"};